import { render, staticRenderFns } from "./MenuLrPlusHeader.vue?vue&type=template&id=65faa13e&"
import script from "./MenuLrPlusHeader.vue?vue&type=script&lang=js&"
export * from "./MenuLrPlusHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65faa13e')) {
      api.createRecord('65faa13e', component.options)
    } else {
      api.reload('65faa13e', component.options)
    }
    module.hot.accept("./MenuLrPlusHeader.vue?vue&type=template&id=65faa13e&", function () {
      api.rerender('65faa13e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/menu-lr-plus-header/MenuLrPlusHeader.vue"
export default component.exports